export const DEFAULT_BLOCK_ANIMATION_SPEED = 1;
export const MIN_BLOCK_ANIMATION_SPEED = 0.5;
export const MAX_BLOCK_ANIMATION_SPEED = 4.5;
export const SETTINGS_STORAGE_PREFIX = "xima_user_settings_v1_";
export const BLOCK_ANIMATION_SPEED_GLOBAL_STORAGE_KEY =
  "xima_block_animation_speed_v1";

export const DEFAULT_PREFERENCES = {
  soundEnabled: true,
  animationsEnabled: true,
  autoJoinLastMode: false,
  compactRightPanel: false,
  cameraFollowEnabled: false,
  // Voice control stays off until the player turns it on.
  voiceControlEnabled: false,
  blockAnimationSpeed: DEFAULT_BLOCK_ANIMATION_SPEED,
};

export const normalizeBlockAnimationSpeed = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return DEFAULT_BLOCK_ANIMATION_SPEED;
  return Math.min(
    MAX_BLOCK_ANIMATION_SPEED,
    Math.max(MIN_BLOCK_ANIMATION_SPEED, parsed)
  );
};

export const parsePreferences = (rawValue) => {
  try {
    if (!rawValue) return null;
    const parsed = JSON.parse(rawValue);
    if (!parsed || typeof parsed !== "object") return null;

    return {
      ...DEFAULT_PREFERENCES,
      ...parsed,
      soundEnabled:
        typeof parsed.soundEnabled === "boolean"
          ? parsed.soundEnabled
          : DEFAULT_PREFERENCES.soundEnabled,
      animationsEnabled:
        typeof parsed.animationsEnabled === "boolean"
          ? parsed.animationsEnabled
          : DEFAULT_PREFERENCES.animationsEnabled,
      autoJoinLastMode:
        typeof parsed.autoJoinLastMode === "boolean"
          ? parsed.autoJoinLastMode
          : DEFAULT_PREFERENCES.autoJoinLastMode,
      compactRightPanel:
        typeof parsed.compactRightPanel === "boolean"
          ? parsed.compactRightPanel
          : DEFAULT_PREFERENCES.compactRightPanel,
      cameraFollowEnabled:
        typeof parsed.cameraFollowEnabled === "boolean"
          ? parsed.cameraFollowEnabled
          : DEFAULT_PREFERENCES.cameraFollowEnabled,
      voiceControlEnabled:
        typeof parsed.voiceControlEnabled === "boolean"
          ? parsed.voiceControlEnabled
          : DEFAULT_PREFERENCES.voiceControlEnabled,
      blockAnimationSpeed: normalizeBlockAnimationSpeed(parsed.blockAnimationSpeed),
    };
  } catch {
    return null;
  }
};

export const getPreferencesStorageKey = (email) => {
  const normalizedEmail = String(email || "").trim().toLowerCase();
  return `${SETTINGS_STORAGE_PREFIX}${normalizedEmail || "guest"}`;
};

export const readUserPreferences = (email) => {
  if (typeof window === "undefined") return DEFAULT_PREFERENCES;
  const preferences = parsePreferences(window.localStorage.getItem(getPreferencesStorageKey(email))) || {
    ...DEFAULT_PREFERENCES,
  };
  writeGlobalBlockAnimationSpeed(preferences.blockAnimationSpeed);
  return preferences;
};

export const readGlobalBlockAnimationSpeed = () => {
  if (typeof window === "undefined") return DEFAULT_BLOCK_ANIMATION_SPEED;
  return normalizeBlockAnimationSpeed(
    window.localStorage.getItem(BLOCK_ANIMATION_SPEED_GLOBAL_STORAGE_KEY)
  );
};

export const writeGlobalBlockAnimationSpeed = (value) => {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(
    BLOCK_ANIMATION_SPEED_GLOBAL_STORAGE_KEY,
    normalizeBlockAnimationSpeed(value).toString()
  );
};

export const writeUserPreferences = (email, preferences) => {
  if (typeof window === "undefined") return;
  const normalizedPreferences = parsePreferences(JSON.stringify(preferences)) || {
    ...DEFAULT_PREFERENCES,
  };
  writeGlobalBlockAnimationSpeed(normalizedPreferences.blockAnimationSpeed);
  window.localStorage.setItem(
    getPreferencesStorageKey(email),
    JSON.stringify(normalizedPreferences)
  );
};

export const writeUserPreference = (email, key, value) => {
  const currentPreferences = readUserPreferences(email);
  writeUserPreferences(email, {
    ...currentPreferences,
    [key]: value,
  });
};
